import React, { useState, useEffect } from "react";
import Modal, {
  ModalTransition,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "@atlaskit/modal-dialog";
import Button from "@atlaskit/button/new";
import Textfield from "@atlaskit/textfield";
import { useSelector, useDispatch } from "react-redux";
import { createCredObject } from "../../common/factory/credential.factory";
import { modifySelectedCred, saveCred } from "../../redux/actions/credActions";
import { CRED_OPTIONS } from "../../common/constants/core/cred.constants";
import { toggleLoading } from "../../redux/actions/messageActions";
import AddIcon from "@atlaskit/icon/core/add";

import Select from "@atlaskit/select";
import { useEscapeShortcut } from "../../common/utils/keybindings";

const CreatePage = () => {
  const defaultType = CRED_OPTIONS[2];
  const dispatch = useDispatch();
  const selectedCred = useSelector((state) => state.auth.selectedCred);
  const [isOpen, setIsOpen] = useState(false);
  const [type, setType] = useState(defaultType);

  useEffect(() => {
    if (type !== defaultType) {
      setType(defaultType);
    }
  }, [selectedCred]);

  const close = () => {
    dispatch(modifySelectedCred({}));
    setIsOpen(false);
    setType(defaultType);
  };
  const create = () => {
    dispatch(toggleLoading(true, "Saving..."));
    dispatch(saveCred(selectedCred));
    setIsOpen(false);
  };
  const open = () => {
    console.log(defaultType);
    const credential = createCredObject("", defaultType.value);
    dispatch(modifySelectedCred(credential));
    setIsOpen(true);
  };
  const changeActionName = (e) => {
    selectedCred.name = e.target.value;
    dispatch(modifySelectedCred(selectedCred));
  };
  const onTypeChange = (e) => {
    selectedCred.type = e.value;
    dispatch(modifySelectedCred(selectedCred));
    setType(e);
  };
  const doEscape=()=>{
    if(isOpen){
      setIsOpen(false)
    }
  }
  useEscapeShortcut(doEscape)
  return (
    <>
      <Button
        appearance="primary"
        onClick={open}
        iconBefore={AddIcon}
      >
        <span className="add-credential-button-text">Add credential</span>
      </Button>
      <ModalTransition>
        {isOpen && (
          <Modal shouldCloseOnOverlayClick={false} width={500} height={500}>
            <ModalHeader>
              <ModalTitle>Create</ModalTitle>
            </ModalHeader>
            <ModalBody>
              <label htmlFor="type">Type</label>
              <Select
                spacing={"default"}
                className="ihub-action-method-select"
                value={type}
                options={CRED_OPTIONS}
                placeholder="Select credential type"
                onChange={onTypeChange}
              />
              <br />
              <label htmlFor="action_name">Name</label>
              <Textfield
                name="action_name"
                isCompact={true}
                onChange={changeActionName}
              />
              <br />
            </ModalBody>
            <ModalFooter>
              <Button appearance="subtle" onClick={close}>
                Close
              </Button>
              <Button appearance="primary" onClick={create}>
                Create
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
    </>
  );
};
export default CreatePage;
